import { inr } from "@/lib/api";
import { Plus } from "lucide-react";

export default function BookingList({ bookings, onOpen, onNew }) {
  return (
    <div className="space-y-4" data-testid="booking-list">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h3 className="font-serif text-2xl">Bookings ({bookings.length})</h3>
        <button data-testid="bk-new" onClick={onNew} className="btn-primary flex items-center gap-2"><Plus size={16} /> New Direct Booking</button>
      </div>
      <div className="card overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left border-b" style={{ borderColor: "var(--border)" }}>
            <th className="p-2">Booking</th><th>Guest</th><th>Manager</th><th>Dates</th><th>Amount</th><th>Paid</th><th>Balance</th><th>Status</th><th>Comms</th>
          </tr></thead>
          <tbody>
            {bookings.map((b) => (
              <tr key={b.id} className="border-b cursor-pointer hover:bg-black/[.02]" style={{ borderColor: "var(--border)" }}
                data-testid={`booking-row-${b.booking_reference}`} onClick={() => onOpen(b.id)}>
                <td className="p-2 font-medium">{b.booking_reference}</td>
                <td>{b.full_name}</td>
                <td className="text-xs" data-testid={`booking-manager-${b.booking_reference}`}>{b.responsible_manager?.name || <span style={{ color: "var(--terracotta)" }}>UNASSIGNED</span>}</td>
                <td>{b.check_in_date} → {b.check_out_date}</td>
                <td>{inr(b.booking_amount)}</td>
                <td>{inr(b.verified_paid)}</td>
                <td style={{ color: b.balance_remaining > 0 ? "var(--terracotta)" : "var(--pine)" }}>{inr(b.balance_remaining)}</td>
                <td><span className={b.status === "CONFIRMED" || b.status === "CHECKED_IN" ? "badge-pine" : "badge-terracotta"} style={b.status === "CANCELLED" ? { opacity: 0.55 } : {}}>{b.status}</span></td>
                <td className="text-xs" style={{ color: "var(--muted)" }}>WA: {b.whatsapp_status === "NOT_CONNECTED" ? "Not connected" : b.whatsapp_status}</td>
              </tr>
            ))}
            {bookings.length === 0 && <tr><td colSpan="9" className="p-4 text-sm" style={{ color: "var(--muted)" }}>No bookings yet. Create your first direct booking.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
